import "./artist_art.scss";

import { ArtPieceDetails } from "@components/art_piece_details/art_piece_details";
import { ArtworkBrowser } from "@components/artwork_browser/artwork_browser";
import { ImageUnavailable } from "@components/image_unavailable/image_unvailable";
import * as types from "@root/types";
import React, { FC } from "react";

interface ArtistArtProps {
  artPieces: types.ArtPiece[];
}

const ArtistArt: FC<ArtistArtProps> = ({ artPieces }) => {
  if (!artPieces.length) {
    return (
      <div className="artist-art--empty">
        This artist doesn&apos;t appear to have any art to show.
      </div>
    );
  }

  if (artPieces.length == 1) {
    const piece = artPieces[0];

    return (
      <div className="artist-art--single">
        <div className="artist-art--single--image-wrapper">
          {piece.imageUrls.large ? (
            <img src={piece.imageUrls.large} aria-label={piece.title} />
          ) : (
            <ImageUnavailable />
          )}
        </div>
        <div className="artist-art--single--details-wrapper">
          <ArtPieceDetails artPiece={piece} />
        </div>
      </div>
    );
  }

  return <ArtworkBrowser artPieces={artPieces} />;
};

export { ArtistArt, ArtistArtProps };
